/**
 * Validation utility functions
 */

/**
 * Validate email format
 */
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email.trim());
};

/**
 * Validate name (first name or last name)
 * Must be 2-50 characters after trimming
 */
export const validateName = (name: string): boolean => {
  const trimmed = name.trim();
  return trimmed.length >= 2 && trimmed.length <= 50;
};

/**
 * Validate company name
 * Must be 2-100 characters after trimming
 */
export const validateCompanyName = (name: string): boolean => {
  const trimmed = name.trim();
  return trimmed.length >= 2 && trimmed.length <= 100;
};

/**
 * Validate phone number (basic validation - allows various formats)
 */
export const validatePhoneNumber = (phone: string): boolean => {
  if (!phone.trim()) return true; // Phone is optional
  // Allow digits, spaces, dashes, parentheses, plus sign
  const phoneRegex = /^[0-9\s\-()+ ]{7,20}$/;
  return phoneRegex.test(phone.trim());
};

/**
 * Get validation error message for email
 */
export const getEmailError = (email: string): string | null => {
  if (!email.trim()) return 'Email is required';
  if (!validateEmail(email)) return 'Please enter a valid email address';
  return null;
};

/**
 * Get validation error message for name
 */
export const getNameError = (name: string, fieldName: string): string | null => {
  if (!name.trim()) return `${fieldName} is required`;
  if (!validateName(name)) return `${fieldName} must be 2-50 characters`;
  return null;
};

/**
 * Get validation error message for company name
 */
export const getCompanyNameError = (name: string): string | null => {
  if (!name.trim()) return 'Company name is required';
  if (!validateCompanyName(name)) return 'Company name must be 2-100 characters';
  return null;
};

/**
 * Get validation error message for phone number
 */
export const getPhoneError = (phone: string): string | null => {
  if (!phone.trim()) return null; // Phone is optional
  if (!validatePhoneNumber(phone)) return 'Please enter a valid phone number';
  return null;
};
